import React, {useEffect} from 'react';
import {NavLink, useLocation} from "react-router-dom";

import {CloseIcon} from "../icons";
import {ROUTES} from "../../types";
import clsx from "clsx";

const BurgerMenu = (
  { open, onClose, isClientPage = false }:
  { open: boolean; onClose: () => void; isClientPage?: boolean }
) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      return;
    }

    document.body.style.overflow = 'auto';
  }, [open])

  return (
    <div className={
      clsx(
        "absolute z-50 w-full h-full inset-0 bg-mainBlack/90 duration-150 ease-in",
        open ? "translate-x-0" : "translate-x-[-200%]"
      )
    }>
      <div className="absolute top-[20px] left-[20px] z-50" onClick={onClose}>
        <CloseIcon size="30" />
      </div>
      <div className="h-full flex items-center justify-center flex-col">
        {
          isClientPage
          ? <>
              <NavLink to={ROUTES.APPLICATIONS} className={clsx(
                "text-white text-xl mb-5",
                pathname === ROUTES.APPLICATIONS && "text-yellow"
              )}>Заявки</NavLink>
              <NavLink to={ROUTES.CLIENT_PRODUCT} className={clsx(
                "text-white text-xl mb-5",
                pathname === ROUTES.CLIENT_PRODUCT && "text-yellow"
              )}>Продукты</NavLink>
            </>
          : <>
            <NavLink to={ROUTES.MAIN} className={clsx(
              "text-white text-xl mb-5",
              pathname === ROUTES.MAIN && "text-yellow"
            )}>Главная</NavLink>
            <NavLink to={ROUTES.PRODUCT} className={clsx(
              "text-white text-xl mb-5",
              pathname === ROUTES.PRODUCT && "text-yellow"
            )}>Продукты</NavLink>
            <NavLink to={ROUTES.ABOUT_US} className={clsx(
              "text-white text-xl mb-5",
              pathname === ROUTES.ABOUT_US && "text-yellow"
            )}>О нас</NavLink>
            <NavLink to={ROUTES.SIGN_UP} className={clsx(
              "text-white text-xl mb-5",
              pathname === ROUTES.SIGN_UP && "text-yellow"
            )}>Стать агентом</NavLink>
          </>
        }
      </div>
    </div>
  )
};

export default BurgerMenu;
